const PrivacyRoute = {
  path: 'privacy',
  name: 'Privacidade',
  component: () => import("@/views/privacy/PrivacyPage"),
  meta: {
    fullWidth: true,
    noSpacingBottom: true,
  }
}
export default PrivacyRoute;
